import CiutadellaFont from '../assets/fonts/Ciutadella.ttf';
import DigitalFont from '../assets/fonts/Digital.TTF';
import GothamXNarrowFont from '../assets/fonts/GothamXNarrowBlackItalic.otf';
import MuseoSansFont from '../assets/fonts/MuseoSans.otf';
import PremierLeagueFont from '../assets/fonts/PremierLeague.woff2';
import Qatar2022Font from '../assets/fonts/Qatar2022.woff2';

export default {
  roboto: {
    id: 'roboto',
    isGoogleFont: true,
    family: "'Roboto', sans-serif",
    name: 'Roboto',
    url: 'https://fonts.googleapis.com/css2?family=Roboto:wght@100;300;400;500;700;900&display=swap',
  },
  openSans: {
    id: 'openSans',
    isGoogleFont: true,
    family: "'Open Sans', sans-serif",
    name: 'Open Sans',
    url: 'https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;500;600;700;800&display=swap',
  },
  notoSans: {
    id: 'notoSans',
    isGoogleFont: true,
    family: "'Noto Sans', sans-serif",
    name: 'Noto Sans',
    url: 'https://fonts.googleapis.com/css2?family=Noto+Sans:wght@400;700&display=swap',
  },
  montserrat: {
    id: 'montserrat',
    isGoogleFont: true,
    family: "'Montserrat', sans-serif",
    name: 'Montserrat',
    url: 'https://fonts.googleapis.com/css2?family=Montserrat:wght@100;200;300;400;500;600;700;800;900&display=swap',
  },
  digital: {
    id: 'digital',
    isGoogleFont: false,
    family: "'Digital', system-ui",
    name: 'Digital',
    url: DigitalFont,
  },
  robotoCondensed: {
    id: 'robotoCondensed',
    isGoogleFont: true,
    family: "'Roboto Condensed', sans-serif",
    name: 'Roboto Condensed',
    url: 'https://fonts.googleapis.com/css2?family=Roboto+Condensed:wght@300;400;700&display=swap',
  },
  oswald: {
    id: 'oswald',
    isGoogleFont: true,
    family: "'Oswald', sans-serif",
    name: 'Oswald',
    url: 'https://fonts.googleapis.com/css2?family=Oswald:wght@200;300;400;500;600;700&display=swap',
  },
  museoSans: {
    id: 'museoSans',
    isGoogleFont: false,
    family: "'Museo Sans', system-ui",
    name: 'Museo Sans',
    url: MuseoSansFont,
  },
  gothamXNarrow: {
    id: 'gothamXNarrow',
    isGoogleFont: false,
    family: "'Gotham XNarrow', system-ui",
    name: 'Gotham XNarrow',
    url: GothamXNarrowFont,
  },
  bebasNeue: {
    id: 'bebasNeue',
    isGoogleFont: true,
    family: "'Bebas Neue', cursive",
    name: 'Bebas Neue',
    url: 'https://fonts.googleapis.com/css2?family=Bebas+Neue&display=swap',
  },
  sourceSans: {
    id: 'sourceSans',
    isGoogleFont: true,
    family: "'Source Sans Pro', sans-serif",
    name: 'Source Sans',
    url: '"https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@200;300;400;600;700;900&display=swap',
  },
  anton: {
    id: 'anton',
    isGoogleFont: true,
    family: "'Anton', sans-serif",
    name: 'Anton',
    url: 'https://fonts.googleapis.com/css2?family=Anton&display=swap',
  },
  lobster: {
    id: 'lobster',
    isGoogleFont: true,
    family: "'Lobster', cursive",
    name: 'Lobster',
    url: 'https://fonts.googleapis.com/css2?family=Lobster&display=swap',
  },
  dancingScript: {
    id: 'dancingScript',
    isGoogleFont: true,
    family: "'Dancing Script', cursive",
    name: 'Dancing Script',
    url: 'https://fonts.googleapis.com/css2?family=Dancing+Script:wght@400;500;600;700&display=swap',
  },
  pacifico: {
    id: 'pacifico',
    isGoogleFont: true,
    family: "'Pacifico', cursive",
    name: 'Pacifico',
    url: 'https://fonts.googleapis.com/css2?family=Pacifico&display=swap',
  },
  alfaSlabOne: {
    id: 'alfaSlabOne',
    isGoogleFont: true,
    family: "'Alfa Slab One', cursive",
    name: 'Alfa Slab One',
    url: 'https://fonts.googleapis.com/css2?family=Alfa+Slab+One&display=swap',
  },
  pressStart2P: {
    id: 'pressStart2P',
    isGoogleFont: true,
    family: "'Press Start 2P', cursive",
    name: 'Press Start 2P',
    url: 'https://fonts.googleapis.com/css2?family=Press+Start+2P&display=swap',
  },
  monoton: {
    id: 'monoton',
    isGoogleFont: true,
    family: "'Monoton', cursive",
    name: 'Monoton',
    url: 'https://fonts.googleapis.com/css2?family=Monoton&display=swap',
  },
  passionOne: {
    id: 'passionOne',
    isGoogleFont: true,
    family: "'Passion One', cursive",
    name: 'Passion One',
    url: 'https://fonts.googleapis.com/css2?family=Passion+One&display=swap',
  },
  creepster: {
    id: 'creepster',
    isGoogleFont: true,
    family: "'Creepster', cursive",
    name: 'Creepster',
    url: 'https://fonts.googleapis.com/css2?family=Creepster&display=swap',
  },
  orbitron: {
    id: 'orbitron',
    isGoogleFont: true,
    family: "'Orbitron', sans-serif",
    name: 'Orbitron',
    url: 'https://fonts.googleapis.com/css2?family=Orbitron&display=swap',
  },
  vibur: {
    id: 'vibur',
    isGoogleFont: true,
    family: "'Vibur', cursive",
    name: 'Vibur',
    url: 'https://fonts.googleapis.com/css2?family=Vibur&display=swap',
  },
  qatar2022: {
    id: 'qatar2022',
    isGoogleFont: false,
    family: "'Qatar2022', system-ui",
    name: 'Qatar2022',
    url: Qatar2022Font,
  },
  premierLeague: {
    id: 'premierLeague',
    isGoogleFont: false,
    family: "'PremierLeague', system-ui",
    name: 'PremierLeague',
    url: PremierLeagueFont,
  },
  inter: {
    id: 'inter',
    isGoogleFont: true,
    family: "'Inter', sans-serif",
    name: 'Inter',
    url: 'https://fonts.googleapis.com/css2?family=Inter&display=swap',
  },
  ciutadella: {
    id: 'ciutadella',
    isGoogleFont: false,
    family: "'Ciutadella', system-ui",
    name: 'Ciutadella',
    url: CiutadellaFont,
  },
};
